import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  dialog: {
    gap: theme.spacing.space12,
  },

  qrCode: {
    display: "block",
    width: "138px !important",
    height: "138px !important",
    borderRadius: theme.radius.medium,
  },

  otherControllersContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: theme.spacing.space12,
  },
}));
